<template>
  <header :class="['bg-' + theme, 'header']">
    <div class="logo-wrapper">
      <div id="logo">
        <svg
          fill="#2b2e34"
          xmlns="http://www.w3.org/2000/svg"
          x="0"
          y="0"
          viewBox="0 0 121.8 115.5"
          xml:space="preserve"
        >
          <g fill="#6fbfe6">
            <path
              id="Tracé_427"
              class="st0"
              d="M64.8 115.5c-13 0-23.5-14.2-23.5-31.6 0-2.1.1-4.1.4-6.1.6-4.2 1.9-8.3 3.9-12.1 1.9-3.7 4.6-6.5 7.6-9.4.9-.9 1.6-1.8 2.4-2.7 5.5-7.4 5.1-16.2 4.3-24.8-.3-3.6-.8-7.2-1.6-10.8-1.2-5.2-2.3-18 6.5-18s7.7 12.8 6.6 17.9c-.8 3.6-1.3 7.2-1.6 10.8-.8 8.6-1.2 17.4 4.3 24.8.7 1 1.5 1.9 2.4 2.8 2.9 3 5.6 5.7 7.6 9.4 2 3.8 3.3 7.9 3.9 12.1.3 2 .4 4.1.4 6.1-.1 17.4-10.6 31.6-23.6 31.6"
            />
            <path
              id="Tracé_426"
              class="st0"
              d="M30.8 0c13 0 23.5 14.2 23.5 31.6 0 2.1-.1 4.1-.4 6.1-.7 4.3-2 8.3-3.9 12.1-1.9 3.7-4.6 6.5-7.6 9.4-.9.9-1.7 1.8-2.4 2.8-5.5 7.4-5.1 16.2-4.3 24.8.3 3.6.8 7.2 1.6 10.8 1.1 5.1 2.2 17.9-6.5 17.9s-7.7-12.8-6.6-17.9c.8-3.6 1.3-7.2 1.6-10.8.8-8.6 1.2-17.4-4.3-24.8-.7-1-1.5-1.9-2.4-2.8-2.9-3-5.6-5.7-7.6-9.4-1.9-3.8-3.2-7.8-3.8-12-.3-2-.4-4.1-.4-6.1C7.2 14.2 17.8 0 30.8 0"
            />
          </g>
          <polygon
            points="91.2 50.3 93.7 50.3 95.8 45.2 95.8 40.5 91.2 40.5 91.2 44.8 93 44.8"
          />
          <path
            d="M80.8 45.4H85v-7.8c0-4.3 1.2-6.6 4.6-6.6.6 0 1.2 0 1.8.2v-3.6c-.6-.1-1.3-.2-2-.2-2 0-3.8 1.1-4.7 2.8v-2.6h-3.9v17.8z"
          />
          <rect x="72.1" y="27.6" width="4.1" height="17.7" />
          <rect x="72.1" y="20.4" width="4.1" height="4.2" />
          <path
            d="M59.8 27.2c-5.4 0-8.8 3.7-8.8 9.4 0 5.6 3.4 9.4 8.8 9.4 5.5 0 8.9-3.7 8.9-9.4-.1-5.7-3.5-9.4-8.9-9.4zm-.1 15.5c-2.9 0-4.5-2.4-4.5-6.2 0-3.8 1.7-6.2 4.5-6.2 2.9 0 4.6 2.4 4.6 6.2s-1.7 6.2-4.6 6.2z"
          />
          <path
            d="M39.1 45.4h4.1v-7.8c0-4.3 1.2-6.6 4.6-6.6.6 0 1.2 0 1.8.2v-3.6c-.6-.1-1.3-.2-2-.2-2 0-3.8 1.1-4.7 2.8v-2.6H39l.1 17.8z"
          />
          <rect x="30.4" y="27.6" width="4.1" height="17.7" />
          <rect x="30.4" y="20.4" width="4.1" height="4.2" />
          <path
            id="Tracé_429"
            d="M0 45.4h4.1v-8.7c0-3.4.8-6.2 3.7-6.2 2.4 0 3.1 2.1 3.1 4.5v10.4H15v-8.7c0-3.4.8-6.2 3.8-6.2 2.4 0 3 2.1 3 4.5v10.4h4.1V34.3c0-2.3-.4-4.2-1.5-5.4-1.1-1.1-2.7-1.7-4.2-1.6-2.5 0-4.8.9-6 3-.9-2-2.9-3.2-5-3-2.2-.1-4.3.9-5.5 2.7v-2.4H0v17.8z"
          />
          <rect x="117" y="71.9" width="4.6" height="4.8" />
          <polygon points="117.6 69.3 120.9 69.3 121.8 51.7 116.8 51.7" />
          <path
            d="M92.9 71c.1 4 3 6.2 8 6.2 4.6 0 7.5-2.1 7.5-5.5s-2.8-4.4-5.6-5.2c-2.6-.7-5.3-1.1-5.3-3 0-1.3 1.2-2.1 3-2.1 2.2 0 3.3.9 3.4 3h4.1c0-3.9-2.6-5.9-7.3-5.9-4.5 0-7.4 2.1-7.4 5.4 0 3.9 3.6 4.7 6.6 5.4 2.3.6 4.3 1 4.3 2.8 0 1.4-1.3 2.2-3.2 2.2-2.5 0-3.8-1.1-3.8-3.2l-4.3-.1z"
          />
          <path
            id="Tracé_431"
            d="M89.7 76.6h-4.1v-7.8c0-4.3-1.2-6.6-4.6-6.6-.6 0-1.2 0-1.8.2v-3.6c.6-.1 1.3-.2 2-.2 2 0 3.8 1.1 4.7 2.8v-2.6h3.9l-.1 17.8z"
          />
          <rect x="72.1" y="58.9" width="4.1" height="17.7" />
          <rect x="72.1" y="51.7" width="4.1" height="4.2" />
          <path
            d="M59.8 58.4c-5.4 0-8.8 3.7-8.8 9.4 0 5.6 3.4 9.4 8.8 9.4 5.5 0 8.9-3.7 8.9-9.4-.1-5.6-3.5-9.4-8.9-9.4zM59.7 74c-2.9 0-4.5-2.4-4.5-6.2 0-3.8 1.7-6.2 4.5-6.2 2.9 0 4.6 2.4 4.6 6.2 0 3.8-1.7 6.2-4.6 6.2z"
          />
          <path
            id="Tracé_432"
            d="M47.4 76.6h-4.1v-7.8c0-4.3-1.2-6.6-4.6-6.6-.6 0-1.2 0-1.8.2v-3.6c.6-.1 1.3-.2 2-.2 2 0 3.8 1.1 4.7 2.8v-2.6h3.9l-.1 17.8z"
          />
          <path
            id="Tracé_430"
            d="M25.9 76.6h-4.1v-8.7c0-3.4-.8-6.2-3.7-6.2-2.4 0-3.1 2.1-3.1 4.5v10.4h-4.1v-8.7c0-3.4-.8-6.2-3.8-6.2-2.4 0-3 2.1-3 4.5v10.4H0V65.5c0-2.3.4-4.2 1.5-5.4 1.1-1.1 2.7-1.7 4.2-1.6 2.5 0 4.8.9 6 3 .9-2 2.9-3.2 5-3 2.2-.1 4.2.9 5.5 2.7v-2.4h3.7v17.8z"
          />
          <rect x="30.4" y="58.9" width="4.1" height="17.7" />
          <path id="Tracé_428" d="M30.4 55.8h4.1v-4.2h-4.1v4.2z" />
        </svg>
      </div>
    </div>
    <img class="logo-vd" src="/assets/static/logo-vd.svg" />
    <div class="question-number">
      <div class="question-title">Question</div>
      <div class="question-numbers">
        <span>{{ quiz }}</span>
        <span>/{{ quizMax }}</span>
      </div>
    </div>
  </header>
</template>

<script>
import bus from "./../bus";
export default {
  props: ["color"],
  data() {
    return {
      quiz: 1,
      theme: "start",
    };
  },
  computed: {
    env() {
      return process.env;
    },
    quizMax() {
      return this.env.VUE_APP_NB_QUIZ;
    },
  },
  mounted() {
    let vm = this;
    //
    bus.$on("quizUpdated", function (quiz) {
      vm.quiz = quiz;
      vm.theme = "question";
    });
    //
    bus.$on("quizIsFinished", function (quiz) {
      console.log("C'est fini");
      vm.theme = "start";
    });
  },
};
</script>

<style lang="scss" scoped>
.beat-enter-active {
  animation: beat 1 1s;
}
.beat-leave-active {
  animation: beat 1 1s reverse;
}
@keyframes beat {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.2);
  }
  40% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
